import apiConfig from '../../../config/api'
import { apiRequestorHelper } from '../../../helpers'

const Searches = {
  read: (fromNum = undefined, resultsPerPage = undefined, filters = undefined, userId) => {
    let requestBody = {
      url: apiConfig.url + '/getBusquedas',
      method: 'post',
      body: {
        from: fromNum,
        size: resultsPerPage,
        userId
      }
    }

    if (filters !== null) {
      for (let key in filters) {
        requestBody.body[key] = filters[key]
      }
    }

    return apiRequestorHelper(requestBody)
  },
  exportExcel: (filters = {}) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/excelBusquedasAsync',
      method: 'post',
      body: filters
    })
  },
  updateStatusSearch: (params) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/updateStatusSearch',
      method: 'post',
      body: params
    })
  },
  getBusqHistOC: (id) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/getBusqHistOC',
      method: 'post',
      body: { id }
    })
  },
  saveCommentOC: (id, msg) => {
    return apiRequestorHelper({
      url: apiConfig.url + '/saveCommentOC',
      method: 'post',
      body: { id, msg }
    })
  }
}

export default Searches;
